// form type = V - volume / W - weight

export const formData = [
    {key: 'capsule', type: 'W', text: 'Capsule', value: 'CAPSULE'},
    {key: 'tablet', type: 'W', text: 'Tablet', value: 'TABLET'},
    {key: 'tabletER', type: 'W', text: 'Tablet ER', value: 'TABLET, EXTENDED RELEASE'},
    {key: 'tabletOD', type: 'W', text: 'Tablet OD', value: 'TABLET, ORALLY DISINTEGRATING'},
    {key: 'tabletCH', type: 'W', text: 'Tablet Chewable', value: 'TABLET, CHEWABLE'},
    {key: 'gel', type: 'V', text: 'Gel', value: 'GEL'},
    {key: 'ointment', type: 'V', text: 'Ointment', value: 'OINTMENT'},
    {key: 'cream', type: 'V', text: 'Cream', value: 'CREAM'},
    {key: 'shampoo', type: 'V', text: 'Shampoo', value: 'SHAMPOO'},
    {key: 'liquid', type: 'V', text: 'Liquid', value: 'LIQUID'},
    {key: 'powder', type: 'V', text: 'Powder', value: 'POWDER'},
    {key: 'solution', type: 'V', text: 'Solution', value: 'SOLUTION'},
];

export function formType(form) {
    for( let i = 0; i < formData.length; ++i) {
      if (formData[i].value === form) return formData[i].type
    }
    return null;
}
  

export const measData = [
    {key: 'ea', text: 'Each', value: 'ea'},
    {key: 'tsp', text: 'Teaspoon', value: 'tsp'},
    {key: 'tbsp', text: 'Tablespoon', value: 'tbsp'},
    {key: 'oz', text: 'Ounce', value: 'oz'},
    {key: 'ml', text: 'Milliliter', value: 'ml'},
    {key: 'mg', text: 'Milligram', value: 'mg'},
    {key: 'mcg', text: 'Microgram', value: 'mcg'},
    {key: 'IU', text: 'International Units', value: 'Iu'},
];

export const oftenData = [
    {key: 'daily', text: 'Daily', value: 'daily'},
    {key: 'hour', text: 'Hour', value: 'hour'},
    {key: 'asneeded', text: 'As Needed', value: 'asNeeded'},
];